import React, {useState} from "react"
import {useQuery, useMutation} from "@apollo/client"

import {TmdbImage} from "components/common/Tmdb/TmdbImage"

import showListQuery from 'graphql/Media/Show/query/showList'
import episodeSearchQuery from "graphql/Media/Tmdb/query/searchEpisode"
import episodeAddMutatipon from "graphql/Media/Episode/mutation/episodeAdd"
import {TmdbImageSizeEnum} from "helpers/Tmdb"
import {BackofficePage, BackofficePanel, BackofficeEmptyState} from "components/backoffice/Layout/BackofficePage"

export const EpisodeEdit = (props: any) => {

  const [showSelected, udpateShowSelected] = useState("")
  const [seasonSelected, udpateSeasonSelected] = useState("")
  const [episodeNumber, updateEpisodeNumber] = useState("")

  const {data: {showList = []} = {}} = useQuery(showListQuery)

  const episodeResponse = useQuery(episodeSearchQuery, {
    skip: !!!episodeNumber,
    variables: {
      Show: showSelected,
      episode: Number(episodeNumber),
      season: Number(seasonSelected),
    }
  })

  const [mutate] = useMutation(episodeAddMutatipon)

  const episode = episodeResponse?.data?.search
  const statusCode = episode?.status_code;
  const notFound = !!statusCode

  const Show = showList.find(el => el.id === showSelected)
  const SeasonList = Show?.Season

  const seasonId = SeasonList?.find((el:any) => el.number === Number(seasonSelected))?.id

  const isFormValid = episode && !notFound

  const onSubmit = (e: any) => {
    e.preventDefault()
    mutate({
      variables: {
        tmdbOptions: episode,
        name: episode?.name,
        number: Number(episodeNumber),
        Season: seasonId
      }
    })
    .then(() => console.log("OK"))
  }


  // console.log({SeasonList})


  return <BackofficePage eyebrow="Catalogue" title="Ajouter un épisode" description="Choisissez une série et une saison pour récupérer automatiquement la fiche de l'épisode." icon="fa-photo-video">
    <div className="bo-two-column-layout">
      <BackofficePanel title="Identification" description="Renseignez l'emplacement de l'épisode dans la série." icon="fa-list-ol">
        <form onSubmit={onSubmit}>
          <div className="input-group">
            <span className="input-group-text">Série</span>
            <select value={showSelected} className="form-control" onChange={e => udpateShowSelected(e.target.value)}>
              <option value={""} disabled>Sélectionner une série</option>
              {showList?.map((show: any) => {
                return <option key={`show_${show?.id}`} value={show?.id}>{show?.name}</option>
              })}
            </select>
          </div>
          {showSelected && <div className="input-group">
            <span className="input-group-text">Saison</span>
            <select className="form-control" value={seasonSelected} onChange={e => udpateSeasonSelected(e.target.value)}>
              <option value={""} disabled>Sélectionner une saison</option>
              {SeasonList?.map((season: any) => {
                return <option key={`show_${season?.id}`} value={season?.number}>{season?.number}</option>
              })}
            </select>
          </div>}
          {seasonSelected && <div className="input-group">
            <span className="input-group-text">Épisode</span>
            <input type="number" className="form-control" placeholder="Numéro de l'épisode" value={episodeNumber} onChange={e => updateEpisodeNumber(e.target.value)} />
          </div>}
          <button className="bo-primary-action bo-form-submit" type="submit" disabled={!isFormValid}><span className="fas fa-plus"></span>Ajouter l'épisode</button>
        </form>
      </BackofficePanel>
      <BackofficePanel title="Aperçu TMDB" description="Vérifiez la fiche avant de l'ajouter." icon="fa-eye" className="bo-preview-panel">
        {episode && !notFound && <div className="episode-preview">
          <div className="episode-preview-image">
            <TmdbImage path={
              // @ts-ignore
              episode?.still_path
            } size={TmdbImageSizeEnum.W500} />
          </div>
          <div className="episode-preview-copy">
            <span className="bo-eyebrow">Épisode trouvé</span>
            <h2>{episode?.name}</h2>
            {episode?.overview && <p>{episode.overview}</p>}
          </div>
        </div>}
        {!episode && !notFound && <BackofficeEmptyState title="Aucun épisode sélectionné" description="L'aperçu apparaîtra dès que le numéro d'épisode sera renseigné." icon="fa-image" />}
        {notFound && <BackofficeEmptyState title="Épisode introuvable" description="Vérifiez la série, la saison et le numéro saisis." icon="fa-search-minus" />}
      </BackofficePanel>
    </div>
  </BackofficePage>
}
